export class TextLineConverter {
  public static convert(value: string, isMultiLine: boolean, isFixedText: boolean = false): any {
    if (isMultiLine || isFixedText) { return value; }
    if (!value || (typeof value !== "string") || value === "") { return value; }
    return this.convertString(value);
  }

  private static convertString(text: string): string {
    return text.replace(/\r?\n/g, "");
  }
}
